import React from 'react';
import { getCleanCookieDomain } from '@invitae/location-lite-core';
import { LocationLiteDomainContext } from './context.esm.js';

/**
 * LocationLiteDomainProvider
 *
 * Provides a clean domain name for use in cookies, when given a URL *or* hostname
 *
 * Same function used on the server to guarantee consistent domains set in cookie.
 */
var LocationLiteDomainProvider = function (_a) {
    var _b;
    var apiGateway = _a.apiGateway, children = _a.children, _c = _a.domainFallback, domainFallback = _c === void 0 ? (_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.hostname : _c;
    var apiHostDomain = getCleanCookieDomain(apiGateway);
    /**
     * If the API host is a relative path, we'll need to give our domain normalizer the current hostname
     */
    if (!apiHostDomain) {
        apiHostDomain = getCleanCookieDomain(domainFallback);
    }
    return React.createElement(LocationLiteDomainContext.Provider, { value: apiHostDomain }, children);
};

export { LocationLiteDomainProvider };
//# sourceMappingURL=provider.esm.js.map
